export default __webpack_public_path__ + "michael.2be99a51.jpg";